function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m722.887 222.988-92.129 92.458-92.492 92.096L446.137 500l54.044 53.662 92.129-92.096L630.758 500 499.819 630.529 369.242 500l184.621-184.554-54.044-54.025-211.462 211.748v53.662l184.621 184.554h53.681L711.28 526.831v-53.662l-65.288-65.627 38.448-38.434L815.379 500l-315.56 315.446L184.621 500l315.198-315.446 92.491 92.458 53.682-54.024-118.97-119.29h-54.044L103.736 473.169v53.662l369.242 369.108h53.681l369.242-369.108v-53.662L738.484 315.446l38.447-38.434L1000 500l-500.181 500L0 500 500.181 0l222.706 222.988Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgLogo;